import { Icon } from '@nazka/nazka.mapframe.components'

import './icon-btn-vert.styl'

function IconBtnVert(props) {
  const { inactive, iconProps = {}, onClick } = props

  return (
    <button
      className={`icon-btn-vert ${inactive ? 'icon-btn-vert--inactive' : ''}`}
      type="button"
      onClick={onClick}
    >
      <span className="icon-btn-vert__icon">
        <Icon {...iconProps} />
      </span>
      <span className="icon-btn-vert__text">
        <span className="ellipsis">{props.children}</span>
      </span>
    </button>
  )
}

export default IconBtnVert
